import React from 'react'
import Index from "../../../Index";

export default function AccessPage() {
  return (
    <>
      <div className="error-page-wrapper">
        <div className="error-card">
          <div className="error-logo-container">
            <img src={Index.Png.Logo} className="error-logo-img" alt="Logo" />
          </div>

          <div className="error-gfx-container">
            <h1 className="error-gfx-number">401</h1>
          </div>

          <h2 className="error-card-title">401 Unauthorized</h2>
          
          <p className="error-card-desc">
            We are sorry, but you don't have access or permission to view this page.
            Please contact your system administrator or return to the dashboard.
          </p>

          <div className="error-btn-action">
            <Index.Button
              onClick={() => (window.location.href = "/")}
            >
              Back to Dashboard
            </Index.Button>
          </div>
        </div>
      </div>
    </>
  );
}
